<template>
  <div class="hello">
    <p ref="refMessage"></p>
  </div>
</template>

<script>
import { STATIC_MESSAGE } from '../modules/user-accounts/store';

export default {
  name: 'HelloWorld',
  props: {
    // msg: String,
  },
  data() {
    return {
      homeStaticMessage: null,
    };
  },
  mounted() {
    this.getHomeStaticMessage();
  },
  methods: {
    async getHomeStaticMessage() {
      // this.$parent.$parent.notificationToasts.length = 0;
      try {
        const messageType = 'Home';
        await this.$store.dispatch(STATIC_MESSAGE, { messageType });
        this.homeStaticMessage = this.$store.getters.staticMessage;
        this.$refs.refMessage.innerHTML = this.homeStaticMessage;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
